import { AfterViewInit, Directive, ElementRef, inject, Input } from '@angular/core';

@Directive({
  selector: '[laTeamChipColor]',
  standalone: true,
})
export class TeamChipColorDirective implements AfterViewInit {
  @Input('laTeamChipColor') borderColor?: string;

  private readonly el = inject(ElementRef);

  ngAfterViewInit() {
    this.setColors();
  }

  setColors() {
    const el = this.el.nativeElement as HTMLElement;
    const color = this.borderColor || 'var(--mat-sys-outline-variant)';
    el.style.border = '2px solid ' + color;
    el.style.borderRadius = '8px';
  }
}
